package model

import utils.*
//import utils.ffVss
import kotlin.js.Date

open class Inventario {
    var INV_EMPRESA = 0
    var INV_CODIGO = 0
    var INV_DATA = ff.InicialDate
    var INV_DTPREV = ff.InicialDate
    var INV_DTPROCESSAMENTO = ff.InicialDate
    var INV_TITULO = ""
    var INV_OBSERVACAO = ""
    var INV_ESTCONTROLE = 0
    var INV_FUNCABERTURA = ""
    var INV_FUNCENCERRA = ""

    /*
    fun construtor(EMPRESA: Int, CODIGO: Int, DATA: Date, DTPREV: Date,
                   DTPROCESSAMENTO: Date, TITULO: String, OBSERVACAO: String,
                   ESTCONTROLE: Int, FUNCABERTURA: String, FUNCENCERRA: String): Inventario {
        this.INV_EMPRESA = EMPRESA
        this.INV_CODIGO = CODIGO
        this.INV_DATA = DATA
        this.INV_DTPREV = DTPREV
        this.INV_DTPROCESSAMENTO = DTPROCESSAMENTO
        this.INV_TITULO = TITULO
        this.INV_OBSERVACAO = OBSERVACAO
        this.INV_ESTCONTROLE = ESTCONTROLE
        this.INV_FUNCABERTURA = FUNCABERTURA
        this.INV_FUNCENCERRA = FUNCENCERRA
        return this
    }
     */

    fun construtorLista(_it: String): List<Inventario> {

        //var iLinha = 0
        //ff.println0("iniciou construtorLista")
        val lObj = ArrayList<Inventario>()
        if ((!_it.equals(null)) && (!_it.equals(""))) {
            val it = if (_it.ffCopy(1,1).equals("[")) _it else "[$_it]"
            val lista = JSON.parse<Array<dynamic>>(it)
            ff.println0("@investigar inventário Zuza aqui $it")

            try {
                lista.forEach {
                    val o = Inventario()

                    o.INV_EMPRESA = it.INV_EMPRESA.toString().ffVsi()
                    o.INV_CODIGO = it.INV_CODIGO.toString().ffVsi()

                    o.INV_DATA = it.INV_DATA.toString().ffDsd()
                    o.INV_DTPREV = it.INV_DTPREV.toString().ffDsd()
                    o.INV_DTPROCESSAMENTO = it.INV_DTPROCESSAMENTO.toString().ffDsd()
                    o.INV_TITULO = it.INV_TITULO.toString()
                    o.INV_OBSERVACAO = it.INV_OBSERVACAO.toString()
                    o.INV_ESTCONTROLE = it.INV_ESTCONTROLE.toString().ffVsi()
                    o.INV_FUNCABERTURA = it.INV_FUNCABERTURA.toString()
                    o.INV_FUNCENCERRA = it.INV_FUNCENCERRA.toString()

                    lObj.add(o)
                }
            } catch (e: Exception) {
                println("catch do Inventario()" + e.message)
            }
        }
        ff.println0("Terminou Inventario construtorLista")
        ff.println0(lObj)
        return lObj
    }

    fun getInventario(_recurso: String, cb: (List<Inventario>) -> Unit) {


        Service().getString(_recurso) { _sResult ->
            ff.println0("zuza79")
            ff.println0(_sResult)
            cb(construtorLista(_sResult))
        }
    }


}